import React from 'react';
import PermIdentity from '@material-ui/icons/PermIdentity';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import TitleCard from '../../mui-components/Card/TitleCard';
import MyselfEditor from '../../containers/domain/employee/MyselfEditor';
import RegularCard from 'mui-components/Card/RegularCard';

const ReviewView = () => (
  <GridContainer>
  <ItemGrid xs={12}>
    <RegularCard
      title="Minhas tarefas"
      content={<p>test</p>}
    />
  </ItemGrid>
  </GridContainer>
);

export default ReviewView;
